import { http, id } from 'utils'
import { SET_ITEMS } from 'vx/mutations'

export default {
  namespaced: true,

  state: {
    ellipsePayrolls: []
  },

  actions: {
    async getEllipsePayrolls ({ commit, state }, { customerId, params = {} } = {}) {
      const response = await http.get(`customers/${id(customerId)}/ellipse-payrolls`, { params })
      commit(SET_ITEMS, response.data.data)

      return response
    },

    resetEllipsePayrolls ({ commit }) {
      commit(SET_ITEMS, [])
    }
  },

  mutations: {
    [SET_ITEMS] (state, items) {
      state.ellipsePayrolls = items
    }
  }
}
